module.exports = __webpack_public_path__ + "static/img/choose-online-01.a3db3af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/choose-online-01.jpg
// module id = 254
// module chunks = 1